module.exports = __webpack_public_path__ + "components/advertise-markets/static/guest-d55bc8f479cdf8c2b1375cf7aecb4f0f.jpg";